export const getFileExtension = (fileName) => fileName.substr((fileName.lastIndexOf(".") as number) + 1);
